export default __webpack_public_path__ + "static/media/value_prop.233de0c6.png";